export const SPACE = 16
export const SPACE_HALF = SPACE / 2
export const SPACE_QUARTER = SPACE / 4
